var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"content_whatsapp"},[(_vm.WhatsappActivate == true)?_c('div',[_vm._m(0)]):_vm._e()])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"btn_whatsapp",attrs:{"href":"https://wa.link/pvsj1l","target":"_blank","rel":"noopener noreferrer"}},[_c('img',{staticClass:"icon_what",attrs:{"alt":"avatar havo - havoline motoclub","src":require("../assets/icon/whatsapp.webp")}})])
}]

export { render, staticRenderFns }